<!--
 * @Descripttion: 
 * @Author: Gavin
 * @version: 
 * @Date: 2020-07-28 13:54:54
 * @LastEditTime: 2020-11-18 20:31:21
-->
<template>
  <dl class="physical-list-container">
    <dd class="item" v-for="(item, index) in list" :key="index">
      <!-- 多选checkbox -->
      <label class="check-item" v-if="isChecked">
        <input
          type="checkbox"
          name="selectitem"
          :value="item.alias"
          v-model="selectValue"
        />
        <span class="icon"></span>
      </label>

      <div class="item-content" @click="handleToDetail(item)">
        <span
          class="commission-tag"
          :class="[
            item.is_directional === '1'
              ? 'dx'
              : item.is_activity_valid === '1'
              ? 'xs'
              : '',
          ]"
        ></span>
        <div class="img-box">
          <img v-lazy="item.our_pic_url" alt="" />
        </div>
        <div class="inner">
          <div>
            <!-- 顶部 -->
            <div class="title ellipsis-2">
              <i class="store-logo" :class="[`icon_${item.source}`]"></i>
              {{ item.title }}
            </div>

            <template v-if="item.coupon > 0">
              <div class="coupon">
                <div class="coupon-box">
                  <img
                    class="coupon-logo"
                    src="../../imgs/icon_juan.png"
                    alt=""
                  />
                  <div class="coupon-price">¥{{ item.coupon }}</div>
                </div>
                <p class="information">领券</p>
              </div>
              <div class="price-box after-coupon">
                <span class="label">券后:</span>
                <span class="yuan">¥</span>
                <nr-amount
                  :value="item.final_price"
                  has-separator
                  class="number"
                />
              </div>
            </template>
          </div>
          <div>
            <div
              v-if="!item.coupon || item.coupon <= 0"
              class="price-box after-coupon normal-price"
            >
              <span class="label">单价:</span>
              <span class="yuan">¥</span>
              <nr-amount
                :value="item.final_price"
                has-separator
                class="number"
              />
            </div>
            <div class="price-area" v-if="source === 'selected'">
              <div class="price-box">
                <span class="label">已获佣金:</span>
                <span class="yuan"> ¥ </span>
                <nr-amount
                  :value="item.all_distribution_pay"
                  has-separator
                  class="number"
                />
              </div>
              <div class="price-box">
                <span class="label">已卖出: </span>
                <span class="number">{{ item.all_pay_count }}</span>
                <span class="yuan"></span>
              </div>
            </div>
            <div class="price-area center-no-margin" v-else>
              <div class="commission">
                <div>
                  <span class="label">佣金: </span>
                  <span class="number">{{ returnCommission(item) }}</span>
                  <span class="yuan label">%</span>
                </div>

                <p class="commission-money">
                  约￥{{ returnCommissionMoney(item) }}
                </p>
              </div>
              <!-- 10000以上的变为 xxx.w形式 -->
              <p class="sold" v-if="returnSales(item) > 0">
                已售:{{
                  returnSales(item).toString().length > 4
                    ? round(returnSales(item) / 10000) + "w"
                    : returnSales(item) || 0
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </dd>
    <Empty iconType="2" title="暂无数据" v-if="!list.length" />
  </dl>
</template>

<script>
import { round } from "@/utils";

export default {
  data() {
    return {
      selectValue: [],
    };
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    isNewWindow: {
      type: Boolean,
      default: false,
    },
    isChecked: {
      type: Boolean,
      default: false,
    },
    source: {
      type: String,
      default: "",
    },
    _internal_: {
      type: String,
      default: "",
    },
  },
  methods: {
    round,
    // 清空已选择 item
    clearSelectValue() {
      this.selectValue = [];
    },
    //返回已选择 item
    getSelectValue() {
      return this.selectValue;
    },
    //返回销量
    returnSales(item) {
      return item.source === "2" || item.source === "4"
        ? item.volume
        : item.total_sold_num;
    },
    //返回分佣比例
    returnCommission(item) {
      return round(
        (item.source === 2 || item.source === 4
          ? item.channel_media_distribution_proportion
          : item.final_media_distribution_proportion) * 100
      );
    },
    //返回预估佣金
    returnCommissionMoney(item) {
      return Math.floor(
        item.final_price *
          round(
            item.source === 2 || item.source === 4
              ? item.channel_media_distribution_proportion
              : item.final_media_distribution_proportion
          )
      );
    },
    //去详情
    handleToDetail(item) {
      if (!this.isNewWindow) {
        this.$router.push({
          name: "physicalDetail",
          params: {
            id: item.alias,
          },
          query: {
            category: item.our_category_id,
            _internal_: this._internal_,
          },
        });
      } else {
        let { href } = this.$router.resolve({
          name: "physicalDetail",
          params: {
            id: item.alias,
          },
          query: {
            category: item.our_category_id,
            _internal_: this._internal_,
          },
        });
        let newWindow = window.open("_blank");
        newWindow.location = href;
      }
    },
  },
};
</script>

<style lang="scss">
.physical-list-container {
  margin-top: 12px;

  .item {
    display: flex;
    padding: 24px 32px;
    box-sizing: border-box;
    align-items: center;
  }
  .check-item {
    width: 32px;
    height: 32px;
    margin-right: 30px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    .icon {
      display: block;
      width: 100%;
      height: 100%;
      border: 1px solid #e1e2e5;
      border-radius: 50%;
      box-sizing: border-box;
    }
    input {
      font-size: 300%;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;

      &:checked + .icon {
        border: none;
        background: url("../../../../assets/imgs/icon_selected.svg") no-repeat
          center;
        background-size: 100%;
      }
    }
  }
  .item-content {
    width: 0;
    flex: 1;
    display: flex;
    cursor: pointer;
    position: relative;

    .commission-tag {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;

      &.dx {
        top: -4px;
        left: -4px;
        width: 80px;
        height: 80px;
        background: url("../../../../assets/imgs/icon_physical_dx.svg")
          no-repeat;
        background-size: 100% auto;
      }
      &.xs {
        top: 8px;
        left: -6px;
        width: 140px;
        height: 40px;
        background: url("../../../../assets/imgs/icon_physical_xs.svg")
          no-repeat;
        background-size: 100% auto;
      }
    }
    .img-box {
      width: 244px;
      height: 244px;
      border-radius: 8px;
      overflow: hidden;
      position: relative;
      margin-right: 16px;
      background-color: #fff;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .sales {
      padding: 0 22px 0 16px;
      line-height: 48px;
      font-size: 23px;
      color: #fff;
      border-radius: 0 28px 0px 0px;
      background: rgba($color: #262626, $alpha: 0.7);
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 2;
    }
    .tag-box {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;

      .tag-item {
        width: 54px;
        height: 32px;
        margin-right: 8px;

        &.new {
          background: url("../../imgs/icon_new.svg") no-repeat;
          background-size: contain;
        }
        &.hot {
          background: url("../../imgs/icon_hot.svg") no-repeat;
          background-size: contain;
        }
      }
    }
    .inner {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-bottom: 3px;
      .coupon-box {
        max-width: 110px;
        margin-right: 16px;
        display: flex;
        .coupon-logo {
          width: 36px;
          height: 32px;
        }
        .coupon-price {
          padding: 0 10px 0 5px;
          min-width: 50px;
          height: 32px;
          line-height: 1.8;
          background: url("../../imgs/icon_juan_box.png");
          background-size: 100% 100%;
          font-size: 20px;
          font-weight: 400;
          color: #ff7733;
        }
      }
    }
    .title {
      color: #262626;
      line-height: 1.3;
      font-size: 28px;
      font-weight: bold;
    }
    .store-box {
      display: flex;
      align-items: center;
      color: #595959;
      margin-top: 16px;
      font-size: 24px;

      .icon-youzan {
        color: #ee2200;
        font-size: 24px;
        line-height: 1;
      }
      .label {
        flex-shrink: 0;
        display: inline-block;
        position: relative;

        &::after {
          content: "";
          display: inline-block;
          width: 1px;
          height: 16px;
          margin: 0 16px;
          background-color: #bfbfbf;
        }
      }
    }
    .store-logo {
      width: 28px;
      height: 28px;
      display: inline-block;

      &.icon_1 {
        background: url("../../../../assets/imgs/icon_youzan.svg") no-repeat;
        background-size: cover;
      }
      &.icon_2,
      &.icon_4 {
        background: url("../../../../assets/imgs/icon_taobao.svg") no-repeat;
        background-size: cover;
      }
      &.icon_3 {
        background: url("../../../../assets/imgs/icon_jd.svg") no-repeat;
        background-size: cover;
      }
      &.icon_5 {
        background: url("../../../../assets/imgs/icon_pdd.svg") no-repeat;
        background-size: cover;
      }
    }
    .store-name {
      width: 0;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .price-area {
      display: flex;
      justify-content: space-between;
    }

    .coupon {
      display: flex;
      margin: 16px 0 30px;
    }
    .information {
      padding: 0 4px;
      height: 28px;
      line-height: 1.6;
      background: rgba(255, 119, 51, 0.1);
      border: 2px solid rgba(255, 119, 51, 0.2);
      border-radius: 2px;
      font-size: 20px;
      font-weight: 400;
      color: #ff7733;
    }
    .center-no-margin {
      align-items: center;
      margin-top: unset !important;
    }

    .after-coupon {
      color: $primary-color;
    }
    .commission {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      margin-left: -30px;
      padding-right: 18px;
      height: 48px;
      background: #ff7733;
      border-radius: 8px;
      .label {
        box-sizing: border-box;
        padding-left: 30px;
        font-size: 22px;
        font-weight: 400;
        line-height: 30px;
        color: #ffffff;
      }
      .number {
        // margin-left: 8px;
        font-size: 28px;
        font-weight: bold;
        line-height: 44px;
        color: #ffffff;
      }
      .yuan.label {
        padding-left: unset;
      }
    }
    .sold {
      padding: 0 8px;
      height: 32px;
      background: rgba(239, 75, 97, 0.1);
      border-radius: 4px;
      font-size: 22px;
      font-weight: 400;
      line-height: 30px;
      color: #ef4b61;
    }
    .commission-money {
      margin: 0 16px 0 16px;
      font-size: 22px;
      font-weight: 400;
      line-height: 30px;
      color: #ffffff;
      opacity: 0.8;
      .label {
        padding-left: unset !important;
      }
    }
    .normal-price {
      .label {
        color: #babfbf;
      }
    }
    .price-box {
      font-size: 28px;
      line-height: 40px;
      .label {
        font-size: 24px;
      }
      .yuan {
        font-size: 20px;
      }
      .number {
        font-weight: bold;
      }
    }
  }
}
</style>
